import { makeRequest } from "../utils/axios.js"; 
import { createContext, useEffect, useState, useMemo } from "react";

export const AuthContext = createContext();

export const AuthContextProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(() => {
    try {
      const storedUser = localStorage.getItem("user");
      return storedUser ? JSON.parse(storedUser) : null;
    } catch (error) {
      console.error("Error reading user from localStorage:", error);
      return null;
    }
  });

  // const [privateKey, setPrivateKey] = useState(() => localStorage.getItem("myPrivateKey") || null);

  const [privateKey, setPrivateKey] = useState(null);

  const [publicKey, setPublicKey] = useState(() => localStorage.getItem("myPublicKey") || null);

  const login = async (inputs) => {
    try {
      const res = await makeRequest.post("/auth/login", inputs, {
        withCredentials: true,
      });
      // setCurrentUser(res.data);
      return res.data; 
    } catch (error) {
      console.error("Login error:", error);
      throw error;
    }
  };

  const loginWeb3 = async (payload) => {
    try {
      const res = await makeRequest.post("/auth/web3/verify", payload, {
        withCredentials: true,
      });
      setCurrentUser(res.data);
      return res.data;
    } catch (error) {
      console.error("Web3 Login error:", error);
      throw error;
    }
  };

  const logout = async () => {
    try {
      await makeRequest.post("/auth/logout", {}, {
        withCredentials: true,
      });
    } catch (err) {
      console.error("Error when calling API logout:", err);
    } finally {
      setCurrentUser(null);
      setPrivateKey(null);
      setPublicKey(null);
      // localStorage.removeItem("myPrivateKey"); 
      // localStorage.removeItem("myPublicKey");
      
      localStorage.removeItem("user");
      localStorage.removeItem("myPublicKey");
      localStorage.removeItem("myPrivateKey"); 
      if (currentUser?.username) {
          localStorage.removeItem(`privateKey_${currentUser.username}`);
          localStorage.removeItem(`publicKey_${currentUser.username}`);
      }
    }
  };

  useEffect(() => {
    if (currentUser) {
      localStorage.setItem("user", JSON.stringify(currentUser));
    } else {
      localStorage.removeItem("user");
    }
  }, [currentUser]);

  const contextValue = useMemo(
    () => ({ 
        currentUser, setCurrentUser, 
        privateKey, setPrivateKey, 
        publicKey, setPublicKey, 
        login, logout , loginWeb3
    }),
    [currentUser, privateKey, publicKey]
  );

  return (
    <AuthContext.Provider value={contextValue}>
      {children}
    </AuthContext.Provider>
  );
};